export default __webpack_public_path__ + "static/media/springBoot.49dc9e45.svg";